







import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface SocleBundle {
    hierarchyOwner: {
        clientCode1: string;
    };
}

@Component({ components: { SimpleText } })
export default class ClientCode extends Vue {
    @Prop( { default: null }) public bundle!: SocleBundle;

    public static getNeededFields(): string[] {
        return [
            "bundle.hierarchyOwner.clientCode1"
        ];
    }
}
